// Orchestrator disabled on VPS — backend handles all routing
export async function runOrchestrator(userMessage, onUpdate) {
  return null;
}